export default __webpack_public_path__ + "images/JP.39b5c77.png";